// extracted by mini-css-extract-plugin
export default {"main":"Body_main__fRwwb"};